import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyDLw9Dw-wQI7I6oLY13HijyCGcy2IqgA2c',
  authDomain: 'pkchampscoach.firebaseapp.com',
  projectId: 'pkchampscoach',
  storageBucket: 'pkchampscoach.firebasestorage.app',
  messagingSenderId: '297281663366',
  appId: '1:297281663366:web:14b55a2de800492908fc07',
  measurementId: 'G-9F17MF4GGZ',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Analytics: lazy + browser-only (avoids SSR/test crashes)
export let analytics = null;
if (typeof window !== 'undefined') {
  isSupported()
    .then((ok) => { if (ok) analytics = getAnalytics(app); })
    .catch(() => {});
}
